import { connect } from "react-redux";
import { router } from "store/router";

const mapDispatchToProps = {
  goto: router.goto.push,
};

export default connect(null, mapDispatchToProps);
